export const FETCH_SAMPLE_DC_APPROVAL_STYLE_REQUEST = 'FETCH_SAMPLE_DC_APPROVAL_STYLE_REQUEST';
export const FETCH_SAMPLE_DC_APPROVAL_STYLE_SUCCESS = 'FETCH_SAMPLE_DC_APPROVAL_STYLE_SUCCESS';
export const FETCH_SAMPLE_DC_APPROVAL_STYLE_FAILURE = 'FETCH_SAMPLE_DC_APPROVAL_STYLE_FAILURE';

export const FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_REQUEST = 'FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_REQUEST';
export const FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_SUCCESS = 'FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_SUCCESS';
export const FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_FAILURE = 'FETCH_SAMPLE_DC_APPROVAL_STYLE_DETAIL_FAILURE';

export const FETCH_SAMPLE_DC_APPROVAL_PP_SAMPLE_REQUEST = 'FETCH_SAMPLE_DC_APPROVAL_PP_SAMPLE_REQUEST';
export const FETCH_SAMPLE_DC_APPROVAL_PP_SAMPLE_SUCCESS = 'FETCH_SAMPLE_DC_APPROVAL_PP_SAMPLE_SUCCESS';
export const FETCH_SAMPLE_DC_APPROVAL_PP_SAMPLE_FAILURE = 'FETCH_SAMPLE_DC_APPROVAL_PP_SAMPLE_FAILURE';

export const CREATE_USER_FORM_SAMPLE_DC_APPROVAL = 'CREATE_USER_FORM_SAMPLE_DC_APPROVAL';

export const CREATE_SAMPLE_DC_APPROVAL_DATA_REQUEST = 'CREATE_SAMPLE_DC_APPROVAL_DATA_REQUEST';
export const CREATE_SAMPLE_DC_APPROVAL_DATA_SUCCESS = 'CREATE_SAMPLE_DC_APPROVAL_DATA_SUCCESS';
export const CREATE_SAMPLE_DC_APPROVAL_DATA_FAILURE = 'CREATE_SAMPLE_DC_APPROVAL_DATA_FAILURE';

export const SAMPLE_DC_APPROVAL_USERFORM_RESET = 'SAMPLE_DC_APPROVAL_USERFORM_RESET';
export const SAMPLE_DC_APPROVAL_FULLFORM_RESET = 'SAMPLE_DC_APPROVAL_FULLFORM_RESET';

export const FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_REQUEST = 'FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_REQUEST';
export const FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_SUCCESS = 'FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_SUCCESS';
export const FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_FAILURE = 'FETCH_SAMPLE_DC_APPROVAL_BY_STYLE_FAILURE';

export const DELETE_SAMPLE_DC_APPROVAL_BY_ID_REQUEST = 'DELETE_SAMPLE_DC_APPROVAL_BY_ID_REQUEST';
export const DELETE_SAMPLE_DC_APPROVAL_BY_ID_SUCCESS = 'DELETE_SAMPLE_DC_APPROVAL_BY_ID_SUCCESS';
export const DELETE_SAMPLE_DC_APPROVAL_BY_ID_FAILURE = 'DELETE_SAMPLE_DC_APPROVAL_BY_ID_FAILURE';
